import axios from 'axios';
import { mfgApi } from '@/pages/mfg/mfgApi';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/shizai`;

export const shizaiApi = {
  // requests
  requests: (params) => axios.get(`${API}/requests`, { params }).then((r) => r.data),
  request: (rid) => axios.get(`${API}/requests/${rid}`).then((r) => r.data),
  createRequest: (b) => axios.post(`${API}/requests`, b).then((r) => r.data),
  updateRequest: (id, b) => axios.put(`${API}/requests/${id}`, b).then((r) => r.data),
  patchRequestCategory: (id, order_category_id) =>
    axios.patch(`${API}/requests/${id}/category`, { order_category_id }).then((r) => r.data),
  patchTechsEntered: (id, entered) =>
    axios.patch(`${API}/requests/${id}/techs-entered`, { entered }).then((r) => r.data),
  bulkPatchRequestCategory: (request_ids, order_category_id) =>
    axios.post(`${API}/requests/bulk-category`, { request_ids, order_category_id }).then((r) => r.data),
  deleteRequest: (id) => axios.delete(`${API}/requests/${id}`).then((r) => r.data),
  // Per-line supplier suggestions (Feb 2026)
  supplierSuggestions: (rid) => axios.get(`${API}/requests/${rid}/supplier-suggestions`).then((r) => r.data),
  patchLineSupplier: (rid, line_index, supplier_id, force = false) =>
    axios.patch(`${API}/requests/${rid}/line-supplier`, { line_index, supplier_id, force }).then((r) => r.data),
  // Batch split multi-supplier REQ into N POs in one sweep (Feb 2026)
  splitOrders: (rid, body = {}) =>
    axios.post(`${API}/requests/${rid}/split-orders`, body).then((r) => r.data),
  // suggest / history
  suggest: (part_no) => axios.get(`${API}/suggest`, { params: { part_no } }).then((r) => r.data),
  history: (params) => axios.get(`${API}/history`, { params }).then((r) => r.data),
  // orders
  orders: (params) => axios.get(`${API}/orders`, { params }).then((r) => r.data),
  deleteOrder: (oid) => axios.delete(`${API}/orders/${oid}`).then((r) => r.data),
  bulkDeleteOrders: (order_ids) => axios.post(`${API}/orders/bulk-delete`, { order_ids }).then((r) => r.data),
  bulkArchiveOrders: (order_ids, archived = true) => axios.post(`${API}/orders/bulk-archive`, { order_ids, archived }).then((r) => r.data),
  adminCounters: () => axios.get(`${API}/admin/counters`).then((r) => r.data),
  resetCounter: (b) => axios.post(`${API}/admin/reset-counter`, b).then((r) => r.data),
  order: (id) => axios.get(`${API}/orders/${id}`).then((r) => r.data),
  createOrder: (b) => axios.post(`${API}/orders`, b).then((r) => r.data),
  updateOrder: (id, b) => axios.put(`${API}/orders/${id}`, b).then((r) => r.data),
  sendOrder: (id, b) => axios.post(`${API}/orders/${id}/send`, b).then((r) => r.data),
  cancelOrder: (id) => axios.post(`${API}/orders/${id}/cancel`).then((r) => r.data),
  setPayment: (id, b) => axios.post(`${API}/orders/${id}/payment`, b).then((r) => r.data),
  approveOrder: (id) => axios.post(`${API}/orders/${id}/approve`).then((r) => r.data),
  rejectOrder: (id, b) => axios.post(`${API}/orders/${id}/reject`, b).then((r) => r.data),
  getConfig: () => axios.get(`${API}/config`).then((r) => r.data),
  setConfig: (b) => axios.put(`${API}/config`, b).then((r) => r.data),
  receiveOrder: (id, b) => axios.post(`${API}/orders/${id}/receive`, b).then((r) => r.data),
  lookup: (order_no) => axios.get(`${API}/lookup`, { params: { order_no } }).then((r) => r.data),
  stats: (params) => axios.get(`${API}/stats`, { params }).then((r) => r.data),
  dashboard: (params) => axios.get(`${API}/dashboard`, { params }).then((r) => r.data),
  // 補充提案 (auto-reorder suggestions)
  reorderSuggestions: (params) => axios.get(`${API}/reorder-suggestions`, { params }).then((r) => r.data),
  createReorderRequests: (b) => axios.post(`${API}/reorder-suggestions/create-requests`, b).then((r) => r.data),
  // masters (accounting)
  accountCodes: () => axios.get(`${API}/account-codes`).then((r) => r.data),
  assetCategories: () => axios.get(`${API}/asset-categories`).then((r) => r.data),
  // Monthly accounting export (経理データ出力)
  exportMonthlyPreview: (params) => axios.get(`${API}/export/monthly/preview`, { params }).then((r) => r.data),
  exportMonthlyUrl: (params) => {
    const qs = new URLSearchParams(params).toString();
    return `${API}/export/monthly?${qs}`;
  },
  // TECHSデータ 互換出力 (Feb 2026)
  exportTechsPreview: (params) => axios.get(`${API}/export/techs/preview`, { params }).then((r) => r.data),
  exportTechsUrl: (params) => {
    const qs = new URLSearchParams(params).toString();
    return `${API}/export/techs?${qs}`;
  },
  // 業者請求 照合 (Milestone C - Invoice Reconciliation)
  invoices: (params) => axios.get(`${API}/invoices`, { params }).then((r) => r.data),
  invoiceDetail: (iid) => axios.get(`${API}/invoices/${iid}/detail`).then((r) => r.data),
  createInvoice: (b) => axios.post(`${API}/invoices`, b).then((r) => r.data),
  updateInvoice: (iid, b) => axios.put(`${API}/invoices/${iid}`, b).then((r) => r.data),
  deleteInvoice: (iid) => axios.delete(`${API}/invoices/${iid}`).then((r) => r.data),
  closeMonth: (month, force = false) => axios.post(`${API}/invoices/close`, { month, force }).then((r) => r.data),
  reopenMonth: (month) => axios.post(`${API}/invoices/reopen`, { month }).then((r) => r.data),
  monthCloseStatus: (month) => axios.get(`${API}/invoices/close-status`, { params: { month } }).then((r) => r.data),

  // 部品受注入力 (Parts Request — Milestone D)
  orderCategories: () => axios.get(`${API}/order-categories`).then((r) => r.data),
  suggestOrderCategory: (params) => axios.get(`${API}/order-categories/suggest`, { params }).then((r) => r.data),
  createOrderCategory: (b) => axios.post(`${API}/order-categories`, b).then((r) => r.data),
  updateOrderCategory: (cid, b) => axios.put(`${API}/order-categories/${cid}`, b).then((r) => r.data),
  deleteOrderCategory: (cid) => axios.delete(`${API}/order-categories/${cid}`).then((r) => r.data),
  seedDefaultOrderCategories: () => axios.post(`${API}/order-categories/seed-defaults`).then((r) => r.data),
  // 納入先マスター
  deliveryDestinations: (params) => axios.get(`${API}/delivery-destinations`, { params }).then((r) => r.data),
  createDeliveryDestination: (b) => axios.post(`${API}/delivery-destinations`, b).then((r) => r.data),
  updateDeliveryDestination: (did, b) => axios.put(`${API}/delivery-destinations/${did}`, b).then((r) => r.data),
  deleteDeliveryDestination: (did) => axios.delete(`${API}/delivery-destinations/${did}`).then((r) => r.data),
  importDeliveryDestinations: (file, overwrite) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('overwrite', overwrite ? 'true' : 'false');
    return axios.post(`${API}/delivery-destinations/import`, fd).then((r) => r.data);
  },
  downloadDeliveryDestTemplate: () =>
    axios.get(`${API}/delivery-destinations/import-template`, { responseType: 'blob' }).then((r) => {
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = '納入先インポート_テンプレート.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    }),
  patchPicDelivery: (rid, ddId) => axios.patch(`${API}/pic-requests/${rid}/delivery-destination`, { delivery_destination_id: ddId }).then((r) => r.data),
  picReceiveFix: (rid, b) => axios.patch(`${API}/pic-requests/${rid}/receive-fix`, b).then((r) => r.data),
  myRequests: (params) => axios.get(`${API}/my-requests`, { params }).then((r) => r.data),
  // PIC 受信依頼 inbox (works while shizai module is paused)
  picAccess: () => axios.get(`${API}/pic-access`).then((r) => r.data),
  picRequests: (params) => axios.get(`${API}/pic-requests`, { params }).then((r) => r.data),
  patchPicStatus: (rid, status, voidPurchaseRecords = null) =>
    axios.patch(`${API}/pic-requests/${rid}/status`,
      { status, void_purchase_records: voidPurchaseRecords }).then((r) => r.data),
  patchPicTechs: (rid, entered, techsOrderNo) =>
    axios.patch(`${API}/pic-requests/${rid}/techs-entered`, { entered, techs_order_no: techsOrderNo || null }).then((r) => r.data),
  techsExport: (rid) => axios.get(`${API}/pic-requests/${rid}/techs-export`, { responseType: 'blob' }).then((r) => r.data),
  // 調達方法 (procurement method — PIC managed)
  patchProcurement: (rid, b) => axios.patch(`${API}/pic-requests/${rid}/procurement`, b).then((r) => r.data),
  procurementReport: (year) => axios.get(`${API}/pic-procurement-report`, { params: year ? { year } : {} }).then((r) => r.data),
  // 月次 請求書パック（非TECHS 直接購入・読み取り専用）
  invoicePack: (year, month) => axios.get(`${API}/pic-invoice-pack`, { params: { year, month } }).then((r) => r.data),
  replaceInvoice: (rid, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/pic-requests/${rid}/replace-invoice`, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  invoicePackMonths: (year) => axios.get(`${API}/pic-invoice-pack/months`, { params: { year } }).then((r) => r.data),
  // 請求書AI読み取り（入荷確認の下書き。保存はしない）
  invoiceRead: (rid, photoId) => axios.post(`${API}/pic-requests/${rid}/invoice-read`, { photo_id: photoId }).then((r) => r.data),
  myRequest: (rid) => axios.get(`${API}/my-requests/${rid}`).then((r) => r.data),
  createMyRequest: (b) => axios.post(`${API}/my-requests`, b).then((r) => r.data),
  updateMyRequest: (rid, b) => axios.put(`${API}/my-requests/${rid}`, b).then((r) => r.data),
  cancelMyRequest: (rid) => axios.delete(`${API}/my-requests/${rid}`).then((r) => r.data),
  cancelMyRequestSoft: (rid) => axios.post(`${API}/my-requests/${rid}/cancel`).then((r) => r.data),
  picReceivingLookup: (code) => axios.get(`${API}/pic-receiving/lookup`, { params: { code } }).then((r) => r.data),
  picReceive: (rid, b) => axios.post(`${API}/pic-requests/${rid}/receive`, b).then((r) => r.data),
  // 入荷確認 (arrival confirmation — actual purchase price → master sync)
  arrivalPreview: (rid) => axios.get(`${API}/pic-requests/${rid}/arrival-preview`).then((r) => r.data),
  // C. 入荷登録（台帳登録）の結果を依頼の明細に書き戻す
  markAssetRegistration: (rid, b) => axios.post(`${API}/pic-requests/${rid}/asset-registration`, b).then((r) => r.data),
  confirmArrival: (rid, b) => axios.post(`${API}/pic-requests/${rid}/confirm-arrival`, b).then((r) => r.data),
  // TECHS送料配賦 (TECHS-NOA 実績取込 + 送料の数量按分)
  techsAllocationConfig: () => axios.get(`${API}/techs-allocation/config`).then((r) => r.data),
  setTechsAllocationConfig: (enabled) => axios.put(`${API}/techs-allocation/config`, { enabled }).then((r) => r.data),
  techsImportPreview: (rid, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/pic-requests/${rid}/techs-import/preview`, fd).then((r) => r.data);
  },
  techsImportApply: (rid, b) => axios.post(`${API}/pic-requests/${rid}/techs-import/apply`, b).then((r) => r.data),
  techsRecalcAllocation: (rid, b) => axios.post(`${API}/pic-requests/${rid}/shipping-allocation/recalculate`, b || {}).then((r) => r.data),
  shippingAllocation: (rid) => axios.get(`${API}/pic-requests/${rid}/shipping-allocation`).then((r) => r.data),
  uploadPicInvoice: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/pic-requests/upload-invoice`, fd).then((r) => r.data);
  },
  // 部品受注入力からの新規マスター登録は廃止（2026-08）— createItemFromRequest 削除済み。
  // 品目の登録は 製造管理 / エンジニアリング / 資産 の各画面で行う。
  // shared with manufacturing
  departments: mfgApi.departments,
  suppliers: mfgApi.suppliers,
  locations: mfgApi.locations,
  items: mfgApi.items,
};

export const yen = (n) => '¥' + Number(n || 0).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' });
export const num = (n) => Number(n || 0).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' });

// 入数: returns pack display info when qty is an exact multiple of pack_size, else null
export const packOf = (line) => {
  const ps = Number(line?.pack_size) || 0;
  const qty = Number(line?.qty) || 0;
  if (ps <= 0 || qty <= 0) return null;
  const packs = qty / ps;
  if (Math.abs(packs - Math.round(packs)) > 1e-9) return null;
  return {
    packs: Math.round(packs),
    packUom: line.pack_uom || '袋',
    pieces: qty,
    packSize: ps,
    packPrice: Math.round((Number(line.unit_price) || 0) * ps * 100) / 100,
  };
};

export const ORDER_STATUSES = ['draft', 'ordered', 'partially_received', 'received', 'cancelled'];
export const ORDER_TYPE_BADGE = {
  purchase: 'bg-zinc-100 text-zinc-600 border-zinc-200',
  subcontract: 'bg-orange-50 text-orange-700 border-orange-200',
};
export const ORDER_STATUS_BADGE = {
  draft: 'bg-zinc-100 text-zinc-600 border-zinc-200',
  ordered: 'bg-blue-50 text-blue-700 border-blue-200',
  partially_received: 'bg-amber-50 text-amber-700 border-amber-200',
  received: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  cancelled: 'bg-rose-50 text-rose-700 border-rose-200',
};
export const APPROVAL_BADGE = {
  not_required: 'bg-zinc-100 text-zinc-500 border-zinc-200',
  pending: 'bg-amber-50 text-amber-700 border-amber-200',
  approved: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  rejected: 'bg-rose-50 text-rose-700 border-rose-200',
};
export const REQUEST_STATUSES = ['open', 'ordered', 'closed'];
export const REQUEST_STATUS_BADGE = {
  open: 'bg-amber-50 text-amber-700 border-amber-200',
  ordered: 'bg-blue-50 text-blue-700 border-blue-200',
  closed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
};
export const PRIORITY_BADGE = {
  low: 'bg-zinc-100 text-zinc-500 border-zinc-200',
  normal: 'bg-sky-50 text-sky-700 border-sky-200',
  high: 'bg-rose-50 text-rose-700 border-rose-200',
};
